<app-loadable-content [loadingController]="pointOfServiceLoadingController" (onRetry)="loadPointOfService()">
    <app-title>{{ pointOfService.friendlyName }}</app-title>
    <div align="center">
        <app-toolbar [subject]="pointOfService" [actions]="pointOfServiceToolbarModel.actions" [compactActions]="pointOfServiceToolbarModel.compactActions"></app-toolbar>
    </div>
</app-loadable-content>
